
























import { Component, Vue } from "vue-property-decorator";
import WelcomeWidget from "@/components/Widgets/WelcomeWidget.vue";
import SmsCreditLeftWidget from "@/components/Widgets/SmsCreditLeftWidget.vue";
import ProcessesWidget from "@/components/Widgets/ProcessesWidget.vue";
import CommunicationsWidget from "@/components/Widgets/CommunicationsWidget.vue";
import AdminWidget from "@/components/Widgets/AdminWidget.vue";
import ReportWidget from "@/components/Widgets/ReportWidget.vue";
import CommunicationsPortalWidget from "@/components/Widgets/CommunicationsPortalWidget.vue";
import { General } from "@/services/General";
import { ClaimEnum } from '../../services/ClaimEnum';
import PendingActivitiesWidget from "../Widgets/PendingActivitiesWidget.vue";
import EmergencyContact from "../EmergencyContact.vue";
import { MenuItem } from "@/services/MenuItem";

@Component({
  components: {
    WelcomeWidget,
    ProcessesWidget,
    CommunicationsWidget,
    AdminWidget,
    ReportWidget,
    CommunicationsPortalWidget,
    PendingActivitiesWidget,
    EmergencyContact,
    SmsCreditLeftWidget
  },
})
export default class Home extends Vue {
  loading: boolean = false;
  selectedRegion: any = null;
  regionsOptions: any = [{ value: null, text: "Please select one region" }];
  singlePage: MenuItem = null;

  async mounted() {
    this.fixResize();
    let app = this;
    window.onresize = () => {
      app.fixResize();
    };

    this.singlePage = this.$store.getters.getSingleMenuItem;
    if (this.singlePage) this.$router.push(this.singlePage.href);
    
  }

  offsetWidth: number = 0;
  vfOptions: any = {
    autoplay: true,
    path: "../../images/slide/",
  };
  vfImages: any = [
    "homepage-kenburn-01-desktop.jpg",
    "homepage-kenburn-03-desktop.jpg",
  ];
  vfTransitions: any = ["fade"];

  get getClaimWidth() {
    return "width:" + this.offsetWidth + "px;";
  }
  get CommunicationsIsActive(){
    return General.CommunicationsIsActive
  }
  fixResize() {
    //this.offsetWidth = document.getElementById('home').offsetWidth;
  }
  RefreshPage() {
    General.RefreshPage();
  }

  get isAuthorizedToolWidgets(): boolean {
      let check = true;
      if(!General.CheckAuthorization(ClaimEnum.CanReportDocuments)) 
        if(!General.CheckAuthorization(ClaimEnum.CanReportDocuments))
          if(!General.CheckAuthorization(ClaimEnum.CanReportProducts))
            check = false;
      return check;
  }
}
